/*
  * Copyright Amazon.com, Inc. and its affiliates. All Rights Reserved.
  * SPDX-License-Identifier: MIT
  *
  * Licensed under the MIT License. See the LICENSE accompanying this file
  * for the specific language governing permissions and limitations under
  * the License.
  */

import React from 'react';

import { I18n } from '@aws-amplify/core';

import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles(() => ({
	button: {
		width: '100%',
	}
}));

export default function LogoutButton() {
	const classes = useStyles();
	const logoutPath = '/logout';

	return (
		<Button
			href={logoutPath}
			variant="contained"
			color="primary"
			className={classes.button}
		>
			{I18n.get("LOGOUT_BUTTON_LABEL")}
		</Button>
	);
}
